import { render, staticRenderFns } from "./Coming.vue?vue&type=template&id=37036f2f&scoped=true&"
import script from "./Coming.vue?vue&type=script&lang=ts&"
export * from "./Coming.vue?vue&type=script&lang=ts&"
import style0 from "./Coming.vue?vue&type=style&index=0&id=37036f2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37036f2f",
  null
  
)

export default component.exports